import { Guardian, GuardianRelationshipStatus, Person } from "../../../Utilities";
import { PersonFormValues } from "../Person";
import { RelationshipFormValues } from "../Relationship";

export type Base = {
	relationshipStatus: Guardian["relationshipStatus"] | null;
};

export type Create = Base & {
	person: PersonFormValues.CreateInGuardian[];
	relationships: RelationshipFormValues.CreateInGuardian[];
};

export type CreateRequiredKey = Extract<keyof Create, "personID">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	relationshipStatus: null,
	person: [PersonFormValues.blankItemInGuardian],
	relationships: [],
};

export type Detail = Base & {
	personID: Person["id"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export const relationshipStatusOptions = [
	{ value: GuardianRelationshipStatus.Married },
	{ value: GuardianRelationshipStatus.Remarried },
	{ value: GuardianRelationshipStatus.SeparatedOrDivorced },
	{ value: GuardianRelationshipStatus.Single },
	{ value: GuardianRelationshipStatus.TogetherButNotMarried },
	{ value: GuardianRelationshipStatus.Widowed },
];
